import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';
import { LocalBusinesses } from '@app/models/LocalBusiness';
import { Router } from '@angular/router';

@Component({
    standalone: false,
    selector: 'app-localbusinesses-list',
    templateUrl: './localbusinesses-list.component.html',
    styleUrls: ['./localbusinesses-list.component.scss'],
})
export class LocalbusinessesListComponent implements OnChanges {
    @Input() localBusinesses?: LocalBusinesses[];
    @Input() localBusinessesFavorite?: LocalBusinesses;
    @Input() localbusinessSelected?: LocalBusinesses;

    @Input() mode!: 'list' | 'select-new-favorite';

    constructor(private router: Router) {}

    @Input() fieldToShowAndSearch: keyof LocalBusinesses = 'legalName';

    @Output() itemIsSelected = new EventEmitter();
    @Output() redirectTo = new EventEmitter<LocalBusinesses>();

    public searchValue: string = '';

    public get filteredLocalBusinesses() {
        return this.localBusinesses ?? [];
    }
    public onItemSelected(item: LocalBusinesses): void {
        if (this.router.url === '/journey' && item.journey === false) {
            this.redirectTo.emit(item);
            return;
        }
        this.itemIsSelected.emit(item);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['localBusinesses'] && this.router.url === '/journey') {
        }
    }
}
